var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoneyDripDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 64",
    width: "100%",
    height: 64,
    "aria-hidden": "true",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--color-accent,#37E5FF)",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-accent,#37E5FF)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("style", null, "\n      .drip { fill: url(#g); }\n      .drop { fill: var(--color-accent,#37E5FF); opacity:.28; transform-origin: center; animation: fall 4.5s ease-in infinite; }\n      .d2 { animation-delay: .8s } .d3 { animation-delay: 1.6s }\n      .d4 { animation-delay: 2.4s } .d5 { animation-delay: 3.2s }\n      @keyframes fall {\n        0% { transform: translateY(-6px) scale(0.8); opacity:.0 }\n        20% { opacity:.28 }\n        70% { transform: translateY(24px) scale(1) }\n        100% { transform: translateY(32px) scale(0.85); opacity:0 }\n      }\n      @media (prefers-reduced-motion: reduce) { .drop { animation: none; } }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "drip",
    d: "M0,0 H800 V32 C730,44 690,30 630,32 C540,36 510,22 440,28 C380,33 330,16 260,24 C210,29 160,18 120,26 C80,34 40,26 0,32 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "drop",
    cx: 120,
    cy: 18,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "drop d2",
    cx: 260,
    cy: 14,
    r: 3.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "drop d3",
    cx: 420,
    cy: 16,
    r: 3.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "drop d4",
    cx: 580,
    cy: 12,
    r: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "drop d5",
    cx: 720,
    cy: 15,
    r: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoneyDripDivider);
export default __webpack_public_path__ + "static/media/honey-drip-divider.9f5d9ff5646e1e3412b40f7bb6c039e5.svg";
export { ForwardRef as ReactComponent };